import { IHttpResponse } from 'angular'
import { ApiResponse } from '@vend/types'

/**
 * A little utility function to extract the "data" field of a JSON API response.
 *
 * @param responseData An HTTP response from a Vend API.
 *
 * @return The contents of the "data" field in the response.
 */
export function extractData<T>(responseData: IHttpResponse<ApiResponse<T>>): T {
  return responseData.data.data
}
